import PasswordConfirmModal from "./PasswordConfirm";

const modalsComponents = {
  PasswordConfirmModal
}

export default modalsComponents